import { knowledgeApiSlice } from "api/knowledgeApi.slice";
import { SectionTitleUnderlined, SeeAllButton, StyledGrid, Tile } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";

export const InteractiveDataResults = () => {
  const translate = useTranslate();

  const currentSearchQuery = useSelector((state) => state.search.currentSearchQuery);
  const currentSources = useSelector((state) => state.search.sources);

  const { data: paginatedInteractiveDataSearchResults, isFetching } =
    knowledgeApiSlice.endpoints.searchInteractiveData.useInfiniteQuery(
      { searchQuery: currentSearchQuery, sourceNames: currentSources.map((source) => source.name) },
      {
        skip: currentSearchQuery.length === 0,
      },
    );

  const interactiveDataSearchResults = paginatedInteractiveDataSearchResults?.pages.flat() ?? [];

  if (currentSearchQuery.length === 0 || interactiveDataSearchResults.length === 0) return null;

  return (
    <>
      <SectionTitleUnderlined
        isLoading={isFetching}
        id="interactiveData"
        rightElement={<SeeAllButton link="/search/interactive-data" />}
      >
        {translate("app.discover.topic.tabs.data.title")}
      </SectionTitleUnderlined>
      <StyledGrid numberOfItems={[1, 2, 3, 4, 5]}>
        {interactiveDataSearchResults.slice(0, 4).map((interactiveData) => (
          <Tile
            key={interactiveData.id}
            title={interactiveData.title}
            subtitle={interactiveData.source?.name}
            link={`/search/interactive-data/${interactiveData.id}`}
            image={interactiveData.images?.thumbnail}
          />
        ))}
      </StyledGrid>
    </>
  );
};
